// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorInfoText from "../Ouroboros.Models.Brands.ErrorInfoText/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Core_Errors from "../Ouroboros.Models.Core.Errors/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var uploadErrorMessage = function (error) {
    return {
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(error),
        info: Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Models_Brands_ErrorInfoText.makeErrorInfoText("Some additional info if needed"))
    };
};
var toErrorMessage = function (output) {
    if (output.info instanceof Data_Maybe.Nothing) {
        return {
            message: output.message,
            info: Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
        };
    };
    if (output.info instanceof Data_Maybe.Just) {
        return {
            message: output.message,
            info: Ouroboros_Services_Clients_Interop_Option.some(output.info.value0)
        };
    };
    throw new Error("Failed pattern match at Ouroboros.Models.Core.ErrorHandlers (line 44, column 3 - line 52, column 8): " + [ output.info.constructor.name ]);
};
var toErrorInput = function (input) {
    return {
        type: input.type,
        message: input.message,
        statusCode: Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Data_Maybe.Nothing.value;
        })(Data_Maybe.Just.create)(input.statusCode)
    };
};
var paymentErrorMessage = function (input) {
    return toErrorMessage(Ouroboros_Models_Core_Errors.paymentErrorMessage(toErrorInput(input)));
};
var passwordResetErrorMessage = function (input) {
    return toErrorMessage(Ouroboros_Models_Core_Errors.passwordResetErrorMessage(toErrorInput(input)));
};
var lifecycleErrorMessage = function (input) {
    return toErrorMessage(Ouroboros_Models_Core_Errors.lifecycleErrorMessage(toErrorInput(input)));
};
var feedbackErrorMessage = function (input) {
    return toErrorMessage(Ouroboros_Models_Core_Errors.feedbackErrorMessage(toErrorInput(input)));
};
var contentErrorMessage = function (input) {
    return toErrorMessage(Ouroboros_Models_Core_Errors.contentErrorMessage(toErrorInput(input)));
};
var cardSetupErrorMessage = function (errorType) {
    var message = (function () {
        if (errorType === "InitializationError") {
            return "Stripe didn't load correctly, refresh the page or try again later.";
        };
        if (errorType === "StripeConnectionError") {
            return "Your payment was submitted but couldn't be confirmed, please try again later.";
        };
        if (errorType === "AddressElementError") {
            return "There was an issue parsing your billing information, please review it or try again later.";
        };
        if (errorType === "CardElementError") {
            return "There was an issue parsing your card information, please review it or try again later.";
        };
        return "An unknown error occurred. Please try again.";
    })();
    return {
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        info: Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
    };
};
var authenticationErrorMessage = function (input) {
    return toErrorMessage(Ouroboros_Models_Core_Errors.authenticationErrorMessage(toErrorInput(input)));
};
var accountErrorMessage = function (input) {
    return toErrorMessage(Ouroboros_Models_Core_Errors.accountErrorMessage(toErrorInput(input)));
};
export {
    accountErrorMessage,
    authenticationErrorMessage,
    contentErrorMessage,
    feedbackErrorMessage,
    lifecycleErrorMessage,
    passwordResetErrorMessage,
    paymentErrorMessage,
    cardSetupErrorMessage,
    uploadErrorMessage
};
//# sourceMappingURL=index.js.map
